export var VALIDATE_CONTACT = {
    validateContact: {
        form: {
            name: 'Nome',
            prefix: 'Prefixo do país',
            phone: 'Telefone',
            active: 'Ativo',
            inactive: 'Inativo',
            tooltip: 'Clique aqui e ative este telefone',
        },
        modal: {
            title: 'Ativação do WhatsApp',
            code: 'Adicione o código enviado ao seu WhatsApp de {{name}} no número{{phone}}.',
            resend: 'Reenviar código em {{seconds}} seg.',
            resendNow: 'Não recebeu o código? reenviar',
            acceptTerms: 'Ao “Confirmar” você aceita que a Rappi entre em contato via WhatsApp, e-mail, telefone ou SMS com fins comerciais. Conheça os <b><a>Termos e condições</a></b> e a <b><c>Política de Privacidade</c></b>.',
            errorValidate: 'O código não é válido',
            successValidate: 'Número de telefone validado com sucesso',
        },
    },
};
